import {
  SET_MOVEABLE_ASSETS,
  SET_MOVEABLE_ASSETS_LOADER,
  SET_MOVEABLE_ASSETS_PAGINATION,
} from 'src/common/actions/constants';

const defaultState = {
  loader: false,
  page_data: [],
  count: {},
  pagination: {
    pageNumber: 1,
    resultPerPage: 50,
    nextOrPrev: 'first',
  },
};

export default (state = defaultState, action) => {
  const { data } = action;
  switch (action.type) {
    case SET_MOVEABLE_ASSETS_LOADER: {
      return {
        ...state,
        loader: data,
      };
    }
    case SET_MOVEABLE_ASSETS: {
      return {
        ...state,
        ...data,
      };
    }

    case SET_MOVEABLE_ASSETS_PAGINATION: {
      return {
        ...state,
        pagination: data,
      };
    }
    default:
      return state;
  }
};
